<script>
import BlockingContainer from '@components/BlockingContainer';
import editFormChange from '@mixins/editFormChange';
import VipModel from '@models/Vip';
import isFunction from 'lodash/isFunction';

export default {
  components: {
    BlockingContainer,
  },
  mixins: [editFormChange],
  props: {
    // eslint-disable-next-line
    loadedId: {
      default: null,
    },
    companyId: {
      default: null,
      required: false,
      type: Number,
    },
    isModal: {
      default: false,
      type: Boolean,
    }
  },
  data() {
    return {
      vip: {
        name:  null,
      },
    };
  },
  mounted() {
    if (this.loadedId) {
      this.$wait.start('vip loading');
      VipModel.find(this.loadedId).then((response) => {
        this.vip = Object.assign({}, this.vip, response.vip);
        this.$wait.end('vip loading');
        this.$nextTick(() => {
          this.initChangeWatcher(['vip'], this.validate);
        });
      });
    }
  },
  methods: {
    validate(callback) {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$wait.start('vip loading');
          this.submit(callback);
        }
      });
    },
    submit(callback) {
      if (this.$route.params.id) {
        this.vip.id = this.$route.params.id;
      }
      new VipModel(this.vip)
        .save()
        .then((response) => {
          this.$emit('submitted', response.vip);
          if (callback && isFunction(callback)) callback();
          this.$wait.end('vip loading');
        })
        .catch(() => this.$wait.end('vip loading'));
    },
  },
};
</script>

<template>
  <div>
    <BlockingContainer v-if="$wait.is('vip loading')"></BlockingContainer>
    <b-form @submit.prevent="validate">
        <b-form-group label="Name:">
          <b-form-input
            id="name"
            v-model="vip.name"
            v-validate="'required|max:255'"
            data-vv-value-path="localValue"
            data-vv-name="name"
            data-vv-as="name"
            type="text"
            :state="errors.has('name') ? false : null"
            aria-describedby="input-feedback-name"
            placeholder="Enter name"
          >
          </b-form-input>

          <b-form-invalid-feedback id="input-feedback-name">
            <template v-show="errors.has('name')">{{ errors.first('name') }}</template>
          </b-form-invalid-feedback>
        </b-form-group>
        <b-button :disabled="!!errors.items.length" type="submit" :variant="'outline-' + (!errors.items.length ? 'dark' : 'danger')">Submit</b-button>
      </b-form>
  </div>
</template>
